export default {"src":"/_next/static/media/safety-by-cilia-logo.bb393baf.svg","height":189,"width":450,"blurWidth":0,"blurHeight":0};